import React from "react";
import AssignmentsRow from "./AssignmentsRow";
import PropTypes from "prop-types";
import {AssignmentModel, AssignmentSortModel} from "../../../../models/assignments/AssignmentModel";
import {AssignmentsTableHeader} from "./AssignmentsTableHeader";

const AssignmentsList = ({assignments, sortOptions}) => {

    const mapAssignmentRows = (assignments) => {
        return assignments.map((assignment, index) => {
            return (
                <AssignmentsRow
                    key={index}
                    assignment={assignment}
                />
            );
        });
    };

    return (
        <div className="assignments-assignments-list">
            <AssignmentsTableHeader sortOptions={sortOptions}/>
            <div className="assignments__rows">
                    {mapAssignmentRows(assignments)}
            </div>
        </div>
    );
};

AssignmentsList.propTypes = {
    assignments: PropTypes.arrayOf(PropTypes.shape(AssignmentModel)).isRequired,
    sortOptions: PropTypes.shape(AssignmentSortModel)
};

export default AssignmentsList;
